export default __webpack_public_path__ + "static/media/selected12.e3cddd20.png";